<template>
  <div class="login-wrap" id="warnTip">
    <svg-icon class="login-logo" icon-class="icon_logo"></svg-icon>
    <div class="warningTip" v-if="isWeixinBrowser">抱歉，暂不支持微信浏览器登录，请更换谷歌浏览器后，复制链接前往 {{provHostName}}<i class="el-icon-document-copy y-c-p y-ml-5 systemColor" title="复制" @click="copyKhgjUrlFn"></i></div>
    <div class="warningTip" v-else>客户管家新登录地址 <a :href="provHostName">{{provHostName}}</a><span class="lastTip">请点击前往</span></div>
  </div>
</template>

<script>
import { copyText } from '@/utils/util';
export default {
  components: {},
  name: 'warnTip',
  mixins: [],
  data() {
    return {
      provHostName: 'https://kh.yto.net.cn'
    };
  },
  computed: {
    isWeixinBrowser() {
      const ua = navigator.userAgent.toLowerCase();
      return ua.indexOf('micromessenger') !== -1;
    }
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  methods: {
    copyKhgjUrlFn() {
      copyText(this.provHostName);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss" scoped>
@import "../../styles/variables";
#warnTip {
  .login-logo {
    position: absolute;
    top: 20px;
    left: 20px;
  }
  .warningTip {
    margin-top: 20px;
    font-size: 20px;
    a {
      color: $blue-style;
      text-decoration: underline;
    }
    .lastTip {
      margin-left: 10px;
    }
  }
}
</style>
